import { useEffect } from 'react';
import Loader from '../../common/Loader';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useLocalStorage from '../../hooks/useLocalStorage';
import { postLoginInternalService } from '../../services/externalv2_2';

const SignInInternal: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [, setToken] = useLocalStorage('token', '');
  const [, setPhase] = useLocalStorage('phase', '');

  const externalToken = searchParams.get('token');
  let path = searchParams.get('path') || '/select-game';

  useEffect(() => {
    if (!externalToken) {
      setToken('');
      setPhase('');
      navigate('/signin', { replace: true });
      return;
    }

    let cancelled = false;

    postLoginInternalService(externalToken)
      .then((json) => {
        if (cancelled) return;

        if (json.resultCode === '20000') {
          const { token, phase } = json.results;
          setToken(token);
          setPhase(phase);
          if (path === '/sornthai/classroom')
            path = '/sornthai/dashboard-teacher';
          navigate(path, { replace: true });
          return;
        }

        setToken('');
        setPhase('');
        navigate('/signin', { replace: true });
      })
      .catch((error) => {
        if (cancelled) return;
        console.error(error);
        setToken('');
        setPhase('');
        navigate('/signin', { replace: true });
      });

    return () => {
      cancelled = true;
    };
  }, [externalToken, navigate, path, setPhase, setToken]);

  return <Loader />;
};

export default SignInInternal;
